import type { SVGProps } from 'react';
const SvgArrows = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="m10 10-1.906 1.96a.13.13 0 0 1-.188 0L6 10m0-4 1.906-1.96a.13.13 0 0 1 .188 0L10 6"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
    />
  </svg>
);
export default SvgArrows;
